import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { InputText } from 'primereact/inputtext';
import { DiseaseAdminModel } from "../../../models/disease";
import { InputTextarea } from 'primereact/inputtextarea';
import Language from '../../../common/components/language/language';
import { Lang } from '../../../common/enums';

interface IProps {
	saveClick: any,
	cancelClick: any,
	isVisible: boolean,
	currentDisease: DiseaseAdminModel
}

interface IState {
	disease: DiseaseAdminModel,
	validationMessage: string,
	selectedLangId: number
}

class DiseaseAddEditDialog extends React.Component<IProps, IState> {

	constructor(props: IProps) {
		super(props);

		this.state = {
			disease: props.currentDisease,
			validationMessage: '',
			selectedLangId: Lang.bg
		};
	}

	handleChange = (key, value) => {
		const disease: DiseaseAdminModel = { ...this.state.disease };
		disease[key] = value;
		this.setState({ disease: { ...disease } });
	};

	handleChangeContent = (key, value) => {
		const disease: DiseaseAdminModel = { ...this.state.disease };
		let diseaseContent = disease.diseaseContent.find(r => r.langId == this.state.selectedLangId);
		if (diseaseContent) {
			diseaseContent[key] = value;
		}
		this.setState({ disease: { ...disease } });
	};

	isValidAddEditForm() {
		let message = '';

		this.setState({
			validationMessage: ''
		});

		// if ((!this.state.disease.diseaseNameBG || this.state.disease.diseaseNameBG.trim() == '') &&
		// 	(!this.state.disease.diseaseNameEN || this.state.disease.diseaseNameEN.trim() == '')) {
		// 	message += "Please enter 'BG name' or 'En name'.<br />";
		// }

		this.setState({
			validationMessage: message
		});

		return message == '';
	}

	handleSaveButton = event => {
		event.preventDefault();

		if (!this.isValidAddEditForm()) return;

		const disease = this.state.disease;

		this.props.saveClick(disease);
	}

	handleCanselButton = () => {
		this.props.cancelClick();
	}

	onLangChange = (langId) => {
		this.setState({ selectedLangId: langId });
	}

	getValueContent = (key) => {
		let diseaseContent = this.state.disease.diseaseContent.find(r => r.langId == this.state.selectedLangId)
		if (diseaseContent && diseaseContent[key]) {
			return diseaseContent[key];
		}
		return '';
	}

	public render() {

		const { disease, selectedLangId } = this.state;

		return (

			<Dialog header="Diseases Form" responsive={true} width="50%"
				modal={true}
				visible={this.props.isVisible}
				onHide={this.handleCanselButton}
				footer={
					<div>
						<Button label="Save" icon="pi pi-check" onClick={this.handleSaveButton} className="p-button-raised" />
						<Button label="Cancel" icon="pi pi-times" onClick={this.handleCanselButton} className="p-button-secondary p-button-raised" />
					</div>}
			>
				<div>

					{this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
					<div className="p-grid p-fluid">
						<Language selectedLang={selectedLangId} onLangChange={this.onLangChange}></Language>
						<div className="p-g-12 p-md-12">
							<label>Disease code:</label>
							<InputText
								name="diseaseCode"
								onChange={(e) => this.handleChange('diseaseCode', e.target['value'])}
								value={disease && disease.diseaseCode ? disease.diseaseCode : ""}
							/>
						</div>
						<div className="p-g-12 p-md-12">
							<label>Name:</label>
							<InputText
								name="diseaseName"
								onChange={(e) => this.handleChangeContent('diseaseName', e.target['value'])}
								value={this.getValueContent('diseaseName')}
							/>
						</div>
						<div className="p-g-12 p-md-12">
							<label>Description:</label>
							<InputTextarea rows={5} cols={30}
								onChange={(e) => this.handleChangeContent('diseaseDesc', e.target['value'])}
								value={this.getValueContent('diseaseDesc')}
							/>
						</div>
					</div>

				</div>
			</Dialog >
		)
	}
}

export default DiseaseAddEditDialog;